var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-p-4 tw-bg-white tw-rounded-2xl md:tw-p-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }